<template><section><h2>Group Column Chart 分组柱状图</h2>
<block-demo tip="" source="const data = [
  {
    product: &quot;05-08&quot;,
    year: &quot;图例一&quot;,
    sales: 42,
  },
  {
    product: &quot;05-08&quot;,
    year: &quot;图例二&quot;,
    sales: 78.2,
  },
  {
    product: &quot;05-08&quot;,
    year: &quot;图例三&quot;,
    sales: 62,
  },
  {
    product: &quot;05-09&quot;,
    year: &quot;图例一&quot;,
    sales: 80,
  },
  {
    product: &quot;05-09&quot;,
    year: &quot;图例二&quot;,
    sales: 108,
  },
  {
    product: &quot;05-09&quot;,
    year: &quot;图例三&quot;,
    sales: 64,
  },
  {
    product: &quot;05-10&quot;,
    year: &quot;图例一&quot;,
    sales: 36,
  },
  {
    product: &quot;05-10&quot;,
    year: &quot;图例二&quot;,
    sales: 91,
  },
  {
    product: &quot;05-10&quot;,
    year: &quot;图例三&quot;,
    sales: 56,
  },
]
const { Chart, Bar, Tooltip, Axis, Legend } = qcharts
const chart = new Chart({
  container: &quot;#app&quot;,
})
chart.source(data, {
  row: &quot;year&quot;,
  value: &quot;sales&quot;,
  text: &quot;product&quot;,
})
const bar = new Bar({
  transpose: false,
  barWidth: 20,
})
const tooltip = new Tooltip()
const colors = [&quot;#F00&quot;, &quot;#FF0&quot;, &quot;#0FF&quot;]
const legend = new Legend().style(&quot;point&quot;, (i, j, k) =&gt; {
  return {
    pointType: &quot;star&quot;,
    angles: 5,
    innerRadius: 4,
    outerRadius: 8,
    fillColor: colors[k],
    translate: [2, 5],
  }
})
const axisBottom = new Axis().style(&quot;grid&quot;, false)
const axisLeft = new Axis({ orient: &quot;left&quot; })
  .style(&quot;axis&quot;, false)
  .style(&quot;scale&quot;, false)
chart.append([bar, tooltip, axisBottom, axisLeft, legend])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-08"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例一"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">42</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-08"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例二"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">78.2</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-08"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例三"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">62</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-09"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例一"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">80</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-09"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例二"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">108</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-09"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例三"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">64</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-10"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例一"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">36</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-10"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例二"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">91</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-10"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例三"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">56</span>,
  },
]
<span class="hljs-keyword">const</span> { Chart, Bar, Tooltip, Axis, Legend } = qcharts
<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">"#app"</span>,
})
chart.source(data, {
  <span class="hljs-attr">row</span>: <span class="hljs-string">"year"</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">"sales"</span>,
  <span class="hljs-attr">text</span>: <span class="hljs-string">"product"</span>,
})
<span class="hljs-keyword">const</span> bar = <span class="hljs-keyword">new</span> Bar({
  <span class="hljs-attr">transpose</span>: <span class="hljs-literal">false</span>,
  <span class="hljs-attr">barWidth</span>: <span class="hljs-number">20</span>,
})
<span class="hljs-keyword">const</span> tooltip = <span class="hljs-keyword">new</span> Tooltip()
<span class="hljs-keyword">const</span> colors = [<span class="hljs-string">"#F00"</span>, <span class="hljs-string">"#FF0"</span>, <span class="hljs-string">"#0FF"</span>]
<span class="hljs-keyword">const</span> legend = <span class="hljs-keyword">new</span> Legend().style(<span class="hljs-string">"point"</span>, (i, j, k) =&gt; {
  <span class="hljs-keyword">return</span> {
    <span class="hljs-attr">pointType</span>: <span class="hljs-string">"star"</span>,
    <span class="hljs-attr">angles</span>: <span class="hljs-number">5</span>,
    <span class="hljs-attr">innerRadius</span>: <span class="hljs-number">4</span>,
    <span class="hljs-attr">outerRadius</span>: <span class="hljs-number">8</span>,
    <span class="hljs-attr">fillColor</span>: colors[k],
    <span class="hljs-attr">translate</span>: [<span class="hljs-number">2</span>, <span class="hljs-number">5</span>],
  }
})
<span class="hljs-keyword">const</span> axisBottom = <span class="hljs-keyword">new</span> Axis().style(<span class="hljs-string">"grid"</span>, <span class="hljs-literal">false</span>)
<span class="hljs-keyword">const</span> axisLeft = <span class="hljs-keyword">new</span> Axis({ <span class="hljs-attr">orient</span>: <span class="hljs-string">"left"</span> })
  .style(<span class="hljs-string">"axis"</span>, <span class="hljs-literal">false</span>)
  .style(<span class="hljs-string">"scale"</span>, <span class="hljs-literal">false</span>)
chart.append([bar, tooltip, axisBottom, axisLeft, legend])
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>